// Components==============
import { useContext } from 'react';
import { GlobalTranslateContext } from 'utilities/GlobalContext/GlobalTranslate';
// =========================

export function useTranslate() {
  const translate = useContext(GlobalTranslateContext);

  return translate;
}
